<!-- LOGO -->

<!-- EXPANDED -->
<ng-container *ngIf="isExpanded === true; else collapsed;">
    <div class="h-16 relative">
        <img src="../../../../../../assets/logo/mindpop-logo.svg" class="h-14 w-auto" alt="Mindpop Logo">
    </div>
</ng-container>

<!-- COLLAPSED -->
<ng-template #collapsed>
    <img src="../../../../../../assets/logo/mindpop-logo.svg" class="h-8" alt="Mindpop Logo">
</ng-template>
